module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-row user-list-item clickable",
    on: {
      "click": _vm.showForm
    }
  }, [(_vm.showCheckbox) ? _c('div', {
    staticClass: "table-col table-col-collapsed",
    class: {
      'table-modal-rd': _vm.listCarousel
    }
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    on: {
      "click": function($event) {
        return _vm.checkboxSelectUser(_vm.user)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected
    }
  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-collapsed user-miniature",
    class: {
      'table-modal-rd': _vm.listCarousel
    }
  }, [_c('div', {
    staticClass: "user-miniature-wrapper"
  }, [_c('div', {
    staticClass: "user-miniature-picture-wrapper"
  }, [_c('img', {
    staticClass: "user-miniature-picture",
    attrs: {
      "src": _vm.user.picture_url
    }
  })])])]), _c('div', {
    staticClass: "table-col table-col-150",
    class: {
      'table-modal-rd': _vm.listCarousel
    }
  }, [_c('div', {
    staticClass: "identity"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user_name))]), (!_vm.listCarousel) ? _c('div', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.email))]) : _vm._e()])]), (!_vm.listCarousel) ? _c('div', {
    staticClass: "table-col table-col-100"
  }, [_c('div', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.user.human_role))])]) : _vm._e()]), (_vm.show_form && _vm.user.id != _vm.current_user.id && _vm.can_show_form && !_vm.listCarousel) ? _c('div', {
    staticClass: "table-row form user-form"
  }, [(_vm.user.name) ? _c('div', {
    staticClass: "table-col user-actions table-col-80"
  }, [_c('span', {
    staticClass: "role-label"
  }, [_vm._v(_vm._s(_vm.$t('users.attributes.role')) + ":")]), _c('br'), _c('dropdown-select', {
    attrs: {
      "options": _vm.role_options,
      "selected": _vm.user.role
    },
    on: {
      "input": _vm.setRole
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "table-col user-actions table-col-20"
  }, [_c('span', {
    staticClass: "role-label"
  }, [_vm._v(_vm._s(_vm.$t('users.attributes.status')) + ":")]), _c('br'), (!_vm.confirmed) ? _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t('users.status.pending')))]) : _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t('users.status.active')))])]), _c('div', {
    staticClass: "table-col user-actions"
  }, [_c('span', {
    staticClass: "role-label"
  }, [_vm._v(_vm._s(_vm.$t('users.attributes.email')) + ":")]), _c('br'), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_email),
      expression: "new_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "user-email",
    class: {
      pending: !_vm.confirmed
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": _vm.user.email,
      "disabled": !_vm.confirmed
    },
    domProps: {
      "value": (_vm.new_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_email = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    key: "email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), (!_vm.confirmed) ? _c('button', {
    staticClass: "btn btn-info resend-invite",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.$t('users.actions.invite.resend'),
      "data-placement": "top"
    },
    on: {
      "click": _vm.resendUserInvite
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  })]) : _vm._e()], 1)]), _c('div', {
    staticClass: "buttons-wrapper"
  }, [(_vm.confirmed) ? _c('button', {
    staticClass: "btn btn-primary save-user",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]) : _vm._e(), (!_vm.listCarousel) ? _c('button', {
    staticClass: "btn btn-danger destroy-user",
    on: {
      "click": _vm.destroyUser
    }
  }, [_vm._v(_vm._s(_vm.$t('users.actions.delete.delete')))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-261ef371!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/list_item.vue
// module id = 1051
// module chunks = 1